import React from "react";
import { useNavigate } from "react-router-dom";
import { Github, Mail, Globe } from "lucide-react";
import {
  FileText,
  Edit,
  BarChart3,
  ArrowRight,
  Settings,
  DownloadIcon,
} from "lucide-react";
import logo from "./MElogo.jpeg";
const Logo = () => (
  <img src={logo} alt="Blast Stope Recovery" className="h-12 w-15" />
);

const Header = () => {
  const navigate = useNavigate();
  return (
    <header className="bg-white/70 backdrop-blur-lg shadow-lg sticky top-0 z-30 border-b border-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex justify-between items-center h-20">
          {/* Logo & Branding */}
          <div className="flex items-center space-x-5">
            <Logo />
            <div>
              <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">
                Stope Recovery
              </h1>
              <p className="text-sm text-gray-500">
                Advanced Analytics & Visualization
              </p>
            </div>
          </div>

          {/* Navigation & Settings */}
          <div className="flex items-center space-x-4">
            <button
              className="p-3 rounded-full bg-gray-100 hover:bg-gray-200 transition duration-300 shadow-md focus:ring-2 focus:ring-gray-300"
              onClick={() => navigate("/settings")}
              aria-label="Settings"
            >
              <Settings className="w-6 h-6 text-gray-700" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
